
<div class="right-side right-side-bg p-5">
  <h2>Dashboard</h2>
  <div>
    <!--<h2 class="text-uppercase">Dashboard</h2>-->
    <!-- Dashboard Containers -->


    <div class="card mb-3" *ngIf=" loggedInUserName !== 'RAMP_MSSIDC'">
      <div class="card-header">
        <h2>MSME</h2>
      </div>
      <div class="card-body"  >
        <div class="row">
          <!-- Total MSME Registered -->
          <div class="col-md-2">
            <div class="card bg-gradient-primary box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Total MSME Registered</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ totalMSME }}</div>
                  <button id="btnMSME" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-person-plus fs-4"></i>
                  </button>
                </div>
              </div>
            </div>

          </div>

          <!-- Pending for Verification -->
          <div class="col-md-2">
            <div class="card bg-gradient-warning box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Pending for Verification</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ pendingMSMEVerification }}</div>
                  <button id="btnPending" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-hourglass-split fs-4"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Approved Registration -->
          <div class="col-md-2">
            <div class="card bg-gradient-success box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Approved Registration</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ approvedMSMERegistration }}</div>
                  <button id="btnApproved" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-check-circle fs-4"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Rejected for Query -->
          <div class="col-md-2">
            <div class="card bg-gradient-info box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Rejected for Query</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ rejectedForQueryMSME }}</div>
                  <button id="btnRejectedQuery" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-question-circle fs-4"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Rejected Registration -->
          <div class="col-md-2">
            <div class="card bg-gradient-danger box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Rejected Registration</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{ rejectedMSMERegistration }}</div>
                  <button id="btnRejected" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-person-x fs-4"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>



    <div class="card mb-3" *ngIf="loggedInUserName !== 'RAMP_MSSIDC'">
      <div class="card-header"><h2>IA</h2></div>
      <div class="card-body">
        <div class="row">
          <!-- IA Section -->
          <div class="col-md-2">
            <div class="card bg-gradient-warning box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Total IA Registered</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{totalIA}}</div>
                  <button id="btnIA" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-person-plus fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>
                <!--<p class="card-text mt-2">

              </p>-->
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="card mb-3"    *ngIf=" loggedInUserName !== 'RAMP_MSSIDC'">
      <div class="card-header"> <h2>Proposal</h2></div>
      <div class="card-body">
        <div class="row">
          <!-- Proposal Section -->
          <div class="col-md-2">
            <div class="card bg-gradient-primary box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Total Submitted Proposal</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{totalProposal}}</div>
                  <button id="btnProposal" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                    <i class="bi bi-journal-check fs-4"></i>
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card bg-gradient-warning box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Submitted for Approval</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{submittedProposal}}</div>
                  <button id="btnSubmittedProposal" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-envelope-check fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card bg-gradient-success box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Approved Proposal</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{approvedProposal}}</div>
                  <button id="btnApprovedProposal" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-check-circle fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card bg-gradient-danger box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Rejected Proposal</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{rejectedProposal}}</div>
                  <button id="btnRejectedProposal" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-x-circle fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card bg-gradient-info box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Rejected for Query</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{rejectedForQueryProposal}}</div>
                  <button id="btnRejectedForQueryProposal" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-hourglass fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="card mb-3">
      <div class="card-header"><h2>Event</h2></div>
      <div class="card-body">
        <!-- Event Section -->
        <div class="row">
          <div class="col-md-2">
            <div class="card bg-gradient-primary box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Total Created Events</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{totalEvents}}</div>
                  <button id="btnTotalEvents" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-calendar-event fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card bg-gradient-warning box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Completed Events</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{completedEvents}}</div>
                  <button id="btnCompletedEvents" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-calendar-check fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card bg-gradient-success box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Upcoming Events</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{upcomingEvents}}</div>
                  <button id="btnUpcomingEvents" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-hourglass fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card bg-gradient-danger box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Cancelled Events</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{cancelledEvents}}</div>
                  <button id="btnCancelledEvents" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-x-circle fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card bg-gradient-info box-shadow mb-2 dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51">Postponed Events</h5>
                <div class="d-flex align-items-center">
                  <div class="fs-5">{{postponedEvents}}</div>
                  <button id="btnPostponedEvents" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                    <i class="bi bi-hourglass fs-4"></i>
                    <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>

